export default {"src":"/_next/static/media/light-mode-icon-collapsed.f6da88c4.svg","height":1376,"width":1316,"blurWidth":0,"blurHeight":0};